/**
 * https://vladimirponomarev.com/blog/authentication-in-react-apps-jwt
 *
 */
class Auth {

  /**
   * Authenticate a user. Save a token string in Local Storage
   *
   * @param {string} token
   */
  static authenticateUser(token, roles, username, data) {
    sessionStorage.setItem('token', token)
    sessionStorage.setItem('roles', roles)
    sessionStorage.setItem('username', username)
    sessionStorage.setItem('data', data)
    sessionStorage.setItem('canViewMacroEco', data.canViewMacroEco)
    sessionStorage.setItem('canEditMacroEco', data.canEditMacroEco)
    sessionStorage.setItem('canViewReport', data.canViewReport)
    sessionStorage.setItem('canViewVideo', data.canViewVideo)
    sessionStorage.setItem('email', data.email)
  }

  /**
   * Check if a user is authenticated - check if a token is saved in Local Storage
   *
   * @returns {boolean}
   */
  static isUserAuthenticated() {
    return sessionStorage.getItem('token') ? true : false
  }

  /**
   * Deauthenticate a user. Remove a token from Local Storage.
   *
   */
  static deauthenticateUser() {
    localStorage.clear()
    sessionStorage.clear()
  }

  /**
   * Get a token value.
   *
   * @returns {string}
   */
  static getToken() {
    // get token
    return sessionStorage.getItem('token')
  }

  static getUserName() {
    return sessionStorage.getItem('username')
  }

  static getData() {
    let item = sessionStorage.getItem('data')
    return item === "null" ? null : item
  }

  static getRemember() {
    return sessionStorage.getItem('username') ? true : false
  }

  static getEmail() {
    return sessionStorage.getItem('email')
  }

  static isAdmin(roles: string) {
    return roles === 'admin'
  }
}

export default Auth